import React, { Dispatch } from "react";
interface Props {
  setIncludeCasterInHeight: Dispatch<React.SetStateAction<boolean>>;
}
const ProductCutDownIncludeCasterHeight = ({
  setIncludeCasterInHeight
}: Props) => <div className="cutdown__form form" data-sentry-component="ProductCutDownIncludeCasterHeight" data-sentry-source-file="ProductCutDownIncludeCasterHeight.tsx">
    <label htmlFor="chooseIncludeCasters">
      Should the height of the table be with casters on?
    </label>
    <div className="form__control-container">
      <select id="chooseIncludeCasters" data-testid="chooseIncludeCasters" className="form__control" name="chooseIncludeCasters" onChange={event => {
      setIncludeCasterInHeight(event.target.value === "yes");
    }}>
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
      <label htmlFor="chooseIncludeCasters" className="form__label">
        Include Casters in Height
      </label>
      <i className="icon-down-micro form__control-icon form__control-icon--lg" />
    </div>
  </div>;
export default ProductCutDownIncludeCasterHeight;